import DetailViewContentElement from "../../../common/models/detailView/elements/detailViewContentElement";
import {DetailViewContentElementType} from "../../../common/enums/detailViews/detailViewContentElementType";
import { IObjectModelActionViewReference } from '~/interfaces/contentManagementInterfaces';

export default class Action extends DetailViewContentElement implements IObjectModelActionViewReference {
  action_client_id: string;
  refresh_page_on_completion: boolean;

  constructor() {
    super();
    this.defineProperty("action_client_id", null)
    this.defineProperty('refresh_page_on_completion', false);
  }

  get actionName(): string{
    if (this.is(DetailViewContentElementType.Action)){
      const objectModel =  this.publishedObjectModel || this.objectModel;
      const action = objectModel.findObjectModelAction(this.action_client_id);
      return action.label_title;
    }
    return '';
  }

}
